import { createSlice } from '@reduxjs/toolkit';

interface HeaderState {
  error: string;
  breadcrumb: any;
  headerButton: string;
}

const initialState = {
  breadcrumb: { title: '', add: '', mode: '', chapter: '' },
  headerButton: '',
} as HeaderState;

const headerSlice = createSlice({
  name: 'headerSlice',
  initialState,
  reducers: {
    changeBreadcrumbTitle(state, action) {
      state.breadcrumb.title = action.payload;
    },
    onlyTitle(state, action) {
      state.breadcrumb.title = action.payload;
      state.breadcrumb.add = '';
      state.breadcrumb.mode = '';
      state.breadcrumb.chapter = '';
    },
    changeBreadcrumbMode(state, action) {
      state.breadcrumb.mode = action.payload;
    },
    changeBreadcrumbAdd(state, action) {
      state.breadcrumb.add = action.payload;
    },
    changeBreadcrumbChapter(state, action) {
      state.breadcrumb.chapter = action.payload;
    },
    setBreadcrumbtozero(state) {
      state.breadcrumb = { title: '', add: '', mode: '', chapter: '' };
    },
    headerButtonClickedIs(state, action) {
      state.headerButton = action.payload;
    },
  },
});

export const selectBreadcrumb = state => state.headerSlice.breadcrumb;
export const selectHeaderButton = state => state.headerSlice.headerButton;

export const {
  changeBreadcrumbTitle,
  changeBreadcrumbAdd,
  setBreadcrumbtozero,
  onlyTitle,
  changeBreadcrumbMode,
  changeBreadcrumbChapter,
  headerButtonClickedIs,
} = headerSlice.actions;

export default headerSlice.reducer;
